"use client";

// src/overlays/ariaShouldCloseOnInteractOutside.ts
var ariaShouldCloseOnInteractOutside = (element, ref, state, shouldFocus) => {
  var _a, _b;
  let trigger = ref == null ? void 0 : ref.current;
  const clickOnUnderlay = ((_b = (_a = element == null ? void 0 : element.children) == null ? void 0 : _a[0]) == null ? void 0 : _b.getAttribute("role")) === "dialog";
  if (!trigger || !trigger.contains(element)) {
    if (shouldFocus)
      shouldFocus.current = false;
    if (!clickOnUnderlay)
      state.close();
  } else {
    if (shouldFocus)
      shouldFocus.current = true;
  }
  return clickOnUnderlay;
};

export {
  ariaShouldCloseOnInteractOutside
};
